import React from "react";
import Calendar from "../../../component/TaskAssignment/Calendar";

const CalendarScreen = () => {
  return <div><Calendar /></div>;
};

export default CalendarScreen;